export default __webpack_public_path__ + "static/char-s-30-en-8a904767bdee4910febbfe53d9fc8c73.webp";